import { createHelpers } from 'vuex-map-fields';
import user from "../../components/user/index.vue";

const { getUserField, updateUserField } = createHelpers({
	getterType: `getUserField`,
	mutationType: `updateUserField`,
});


const state = {
	module: {
		is_load: false,
	},
	user: {
		id: 0,
		client_id:0,
		guest: 1,
        is_debug : false,
		phone: 380,
		is_auth: false,
		status: "need_sms",
		need_captcha: true
	},
};

const getters = {

    is_debug(state) {
        if(state.user.hasOwnProperty("client")) {
            let client_data = state.user.client;
            if(client_data.hasOwnProperty("is_debug")) {
                return client_data.is_debug;
            }
        }

        return false;
    },

    getClient(state) {
        return state.user.client;
    },

	getUser(state) {
		return state.user;
	},

	getUserModule(state) {
		return state.module;
	},

	getUserField,

};

// actions
const actions = {

	async LOAD_USER({commit}) {
		state.module.is_load = true;
		await api.get('/internal/user',{
			'headers' : {
				'Authorization': 'Bearer demo'
			}
		}).then(({data}) => {
			state.module.is_load = false;
			if(data.status === "operation_success") {
				state.user = {...state.user,...data.data};
				EventBus.$emit('user_added', state.user);

                try {
                    window.Echo.private("customer." + state.user.client_id)
                        .listen('.order.add', (e) => {
                            EventBus.$emit('new_order_in', e);
                            console.log(e);
                        })
                        .listen('.order.pos_send', (e) => {
                          //  EventBus.$emit('new_order_in', e);
                            console.log('POS_STATE',e);
                        })
                        .listen('.order.print', (e) => {
                            //  EventBus.$emit('new_order_in', e);
                            console.log('PRINT',e);
                        })

                        .listen('.order.delivery_state',(e) => {
                            console.log('change_order_delivery_state',e);
                        })
                        .listen('.order.state',(e) => {
                            console.log('change_order_state',e);
                        });
                }
                catch (e) {
                    console.log('SOCKET_ERR',e);
                }

                try {
                    window.Echo.private("socket.plugin." + state.user.client_id)
                        .listen('.socket.task', (e) => {
                            console.log('socket.task',e);
                        })
                        .listen('.socket.result', (e) => {
                            console.log('socket.result',e);
                        })
                }
                catch (e) {

                }


            }
		}).catch(e => {
			console.log(e);
		})
	},

    async LOAD_FULL_USER({commit}) {
        state.module.is_load = true;
        await api.get('/internal/profile/user',{
            'headers' : {
                'Authorization': 'Bearer demo'
            }
        }).then(({data}) => {
            state.module.is_load = false;
            if(data.status === "operation_success") {
                state.user = {...state.user,...data.data};
                EventBus.$emit('profile_loaded', state.user);
            }
        }).catch(e => {
            console.log(e);
        })
    }
};

// mutations
const mutations = {
	updateUserField,

	addUser(state,data) {
		state.user = data;
		EventBus.$emit('user_added', data);
		state.module.is_load = true;
	},

	setUserField(state,data) {
		state.user = {...state.user,...data};
	},


};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}
